<template>
  <div class="cardListPage">
    <job-header-simple
      header_title="我的收款账号"
      :backRouter="backRouter"
    ></job-header-simple>
    <div
      class="public_empty_section message block"
      v-if="cardList.length == 0 && alipayList.length == 0"
    >
      暂无收款账号
    </div>
    <div class="list">
      <div
        v-for="(item, index) in cardList"
        :key="index"
        class="item"
        :class="{
          type_zhaoshang: item.bank_name == bankTypeArr[0],
          type_jianshe: item.bank_name == bankTypeArr[1],
          type_jiaotong: item.bank_name == bankTypeArr[2],
          type_youzheng: item.bank_name == bankTypeArr[3],
          type_gongshang: item.bank_name == bankTypeArr[4],
          type_nongye: item.bank_name == bankTypeArr[5],
          type_zhongguo: item.bank_name == bankTypeArr[6],
          type_zhongxin: item.bank_name == bankTypeArr[7],
          type_guangda: item.bank_name == bankTypeArr[8],
          type_huaxia: item.bank_name == bankTypeArr[9],
          type_minsheng: item.bank_name == bankTypeArr[10],
          type_guangfa: item.bank_name == bankTypeArr[11],
          type_pingan: item.bank_name == bankTypeArr[12],
          type_hengsheng: item.bank_name == bankTypeArr[13],
          type_zhada: item.bank_name == bankTypeArr[14],
          type_huifeng: item.bank_name == bankTypeArr[15],
          type_dongya: item.bank_name == bankTypeArr[16],
          type_zheshang: item.bank_name == bankTypeArr[17],
          type_hengfeng: item.bank_name == bankTypeArr[18],
          type_pufa: item.bank_name == bankTypeArr[19],
          type_xingye: item.bank_name == bankTypeArr[20],
          type_shanghai: item.bank_name == bankTypeArr[21],
          type_beijing: item.bank_name == bankTypeArr[22],
          type_other: bankTypeArr.indexOf(item.bank_name) < 0,
          'disable-card': item.is_enabled,
        }"
        @click="selectBank(item)"
      >
        <div class="line_top">
          <img
            class="active-bank"
            v-if="usedBankAccount == item.account"
            src="@/assets/bg-bank-active.png"
          />
          <span class="bankName text-ellipsis">{{ item.bank_name }}</span>
          <van-button
            plain
            class="delBtn"
            @click.stop="handleCardDel(item.id, 'bank')"
            >解绑</van-button
          >
        </div>
        <div class="line_no" @click="handleCardShow(cardList, index)">
          <template v-if="item.isShow">
            <van-icon name="eye-o" />
            <span class="no text-ellipsis">{{ item.account }}</span>
          </template>
          <template v-else>
            <van-icon name="closed-eye" />
            <span class="no text-ellipsis">{{ item.secrecyAccount }}</span>
          </template>
        </div>
        <span v-if="item.is_enabled" @click="tipDialogVisible" class="tip"
          >银行卡已禁用!</span
        >
        <div class="uncheckBox" v-if="item.certification_status != '1'">
          <van-button
            plain
            class="delBtn"
            @click.stop="handleCardCheck(item.id, item.account, item.id_number,item.bank_name)"
            >认证</van-button
          >
        </div>
      </div>
    </div>
    <div class="list" v-if="alipayList != null">
      <div
        v-for="(item, index) in alipayList"
        :key="index"
        class="item alipay"
        :class="{ 'disable-card': item.is_enabled }"
        @click="selectBank(item)"
      >
        <div class="line_top">
          <span class="bankName text-ellipsis">{{ item.bank_name }}</span>
          <van-button
            plain
            class="delBtn"
            @click.stop="handleAlipayDel(item.id)"
            >解绑</van-button
          >
          <van-button
            plain
            class="delBtn"
            @click.stop="
              handleAlipayEdit(item.id, item.account, item.id_number)
            "
            >编辑</van-button
          >
        </div>
        <div class="line_no" @click="handleCardShow(alipayList, index)">
          <template v-if="item.isShow">
            <van-icon name="eye-o" />
            <span class="no text-ellipsis">{{ item.account }}</span>
          </template>
          <template v-else>
            <van-icon name="closed-eye" />
            <span class="no text-ellipsis">{{ item.secrecyAccount }}</span>
          </template>
        </div>
        <span v-if="item.is_enabled" @click="tipDialogVisible" class="tip"
          >支付宝已禁用!</span
        >
      </div>
    </div>
    <div
      class="weChatPayList list"
      v-if="weChatPayList != null && weChatPayList.length > 0"
    >
      <div
        v-for="(item, index) in weChatPayList"
        :key="index"
        class="item weChatPay"
        :class="{ 'disable-card': item.is_enabled }"
        @click="selectBank(item)"
      >
        <div class="line_top">
          <span class="bankName text-ellipsis">微信</span>
          <van-button
            plain
            class="delBtn"
            @click.stop="handleCardDel(item.id, 'wx')"
            >解绑</van-button
          >
        </div>
        <div class="line_no">
          <van-icon name="closed-eye" />
          <span class="no text-ellipsis"
            >{{ $store.getters.userInfo.name }} 的微信零钱账户</span
          >
        </div>
        <span v-if="item.is_enabled" @click="tipDialogVisible" class="tip"
          >微信已禁用!</span
        >
      </div>
    </div>
    <div class="bottom">
      <van-row>
        <van-col span="12" v-if="hasAlipay || hasWeChatPay">
          <van-button icon="add" type="info" block @click="toAddBank"
            >增加银行卡</van-button
          >
          <p>支持各种银联储蓄卡</p>
        </van-col>
        <van-col span="24" v-else>
          <van-button icon="add" type="info" block @click="toAddBank"
            >增加银行卡</van-button
          >
          <p>支持各种银联储蓄卡</p>
        </van-col>

        <van-col span="12" v-if="hasAlipay">
          <van-button icon="add" type="info" block plain @click="toAddAliPay"
            >增加支付宝</van-button
          >
          <p>仅支持本人支付宝账号</p>
        </van-col>
        <van-col span="12" v-if="hasWeChatPay">
          <van-button
            icon="add"
            type="info"
            color="#07C160"
            class="weChatPay"
            block
            plain
            @click="toAddWeChatPay"
            >增加微信</van-button
          >
          <p>支持本人已实名的微信账号</p>
        </van-col>
      </van-row>
    </div>
    <van-dialog
      v-model="showWeChatPay"
      title="温馨提示"
      :showCancelButton="true"
      @confirm="confirmAuthorize"
      confirmButtonText="确认并授权"
      class="codeDialog"
    >
      <div class="content">
        <div class="top-content">
          <p>{{ $store.getters.platformName }} 申请获取您的openid信息</p>
          <p class="grey-label">
            实现微信支付至您的零钱账户及保障交易安全所必须的功能
          </p>
        </div>
        <div class="bow-content">
          <p>
            当前收款账号为{{ $store.getters.userInfo.name }}<br />
            请确认是否与微信实名制姓名一致？
          </p>
          <p class="grey-label">
            如不一致，请登录对应微信账号，<br />
            否则无法发放
          </p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { getWechatAutoLoginCode } from '@/utils/auth'
import { saveWechatPayToUser } from '@/api/employee/request'
import { Button, Icon, Dialog, Toast, Row, Col } from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import { browserUA } from '@/utils/browserUA'
import {
  employeeFindListByActiveUser, // 去掉下面获取支付宝收款账号接口，统一用这个。同时增加收款人名称的返回 (type:1 银行卡 type:2 支付宝 type:3 微信 )
  //employeeFindAlipayListByActiveUser,
  checkSupportAliPay,
} from '@/api/employee/request'
import { employeeBankCardDeleteAction } from '@/api/employee/request'
import { checkPayType } from '@/api/employee/request'
import api from '@/api/list'
import { getIndividualHeaderKey } from '@/utils/auth'
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.Component.name]: Dialog.Component,
    jobHeaderSimple,
  },
  data() {
    return {
      ruleForm: {
        code: '',
      },
      hasAlipay: true, //是否支持支付宝支付
      hasWeChatPay: true, //是否支付微信支付
      showWeChatPay: false,
      weChatPayCode: '', //获取微信公众号的code
      routeTo: this.$store.getters.enterRoute,
      usedBankAccount: this.$route.query.usedBankAccount,
      obj: this.$route.query.contractId,
      types: '',
      uncheck: true,
      cardList: [],
      alipayList: [],
      weChatPayList: [], //微信支付列表
      backRouter: '0',
      bankTypeArr: [
        '招商银行',
        '建设银行',
        '交通银行',
        '邮政银行',
        '工商银行',
        '农业银行',
        '中国银行',
        '中信银行',
        '光大银行',
        '华夏银行',
        '民生银行',
        '广发银行',
        '平安银行',
        '恒生银行',
        '渣打银行',
        '汇丰银行',
        '东亚银行',
        '浙商银行',
        '恒丰银行',
        '浦东发展银行',
        '兴业银行',
        '上海银行',
        '北京银行',
      ],
    }
  },
  created() {
    this.initBank()
    this.checkPayType()
  },
  mounted() {
    this.init()
  },
  // 回退页面问题
  beforeRouteEnter(to, from, next) {
    if (from.path == '/addCard') {
      next((vm) => {
        vm.backRouter = window.history.length > 4 ? '-4' : '-1'
      })
    } else if (from.path == '/AddAlipay' || from.path == '/AlipayEdit') {
      next((vm) => {
        vm.backRouter = window.history.length > 3 ? '-3' : '-1'
      })
    }
    next()
  },
  methods: {
    init() {
      const urlParams = new URLSearchParams(window.location.search)
      let code = urlParams.get('code')

      if (code) {
        //获取了code
        this.ruleForm.code = code
        this.saveWechatPay()
      }
    },
    saveWechatPay() {
      let that = this
      saveWechatPayToUser({ code: this.ruleForm.code })
        .then((res) => {
          if (res.data.status == '200') {
            that.$toast('添加成功!')
            that.initBank()
          }
        })
        .catch((err) => {})
    },
    //同意授权
    confirmAuthorize() {
      //是否已经有code
      if (typeof getWechatAutoLoginCode() != 'undefined') {
        this.ruleForm.code = getWechatAutoLoginCode()
        this.saveWechatPay()
      } else {
        let redirectUrl = process.env.VUE_APP_BASE_API + '/#/card'
        let encodedRedirectUrl = encodeURIComponent(redirectUrl)

        // 微信授权URL
        let wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.VUE_APP_WXAPPID}&redirect_uri=${encodedRedirectUrl}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`

        window.location.replace(wechatAuthUrl)
        // let encodeUrl = encodeURIComponent(
        //   process.env.VUE_APP_BASE_API + '/#/card?formType=empowerCode'
        // )

        // window.location.replace(
        //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
        //     process.env.VUE_APP_WXAPPID +
        //     '&redirect_uri=' +
        //     encodeUrl +
        //     '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
        // )
      }
    },
    tipDialogVisible() {
      Dialog.alert({
        title: '提示',
        message:
          ' 该账户存在异常，为避免佣金发放问题，请更换其它状态正常银行卡进行绑定，并在协议进行同步更改。',
        confirmButtonText: '知道了',
        theme: 'round-button',
      }).then(() => {
        // on close
      })
    },
    selectBank(value) {
      // bug-修改 判断当前银行卡是否完成了认证，如果未认证进行提示
      if (value.type == 1 && value.certification_status !== 1) {
        Dialog.alert({
          title: '温馨提示',
          message: '请先完成银行卡的认证！',
          confirmButtonText: '确认',
        })
        return
      }

      // 表示触发了变更付款账号（卡、支付宝）操作
      if (value.type == 2 && this.$route.query.contractId != undefined) {
        // 判断服务商是否支持支付宝付款方式
        checkSupportAliPay(this.$route.query.ocompanyId).then((res) => {
          if (!res.data.data) {
            Dialog.alert({
              title: '温馨提示',
              message: '暂不支持支付宝收款，请选择储蓄卡！',
              confirmButtonText: '确认',
            })
            return
          }
          this.selectBankHandle(value)
        })
      } else {
        this.selectBankHandle(value)
      }
    },
    selectBankHandle(value) {
         //需要调用第三方的认证接口 this.$route.query.type===3
      if (this.$route.query.type == '0') {
        //判断银行可是否被禁用
        if (value.is_enabled && value.is_enabled === true) {
          //被禁用
          Dialog.alert({
            title: '温馨提示',
            message: '该银行卡已被禁用，请联系管理员！',
            confirmButtonText: '确认',
          })
          return
        }
        if (getIndividualHeaderKey()) {
          this.$router.push({
            path: '/individual_baseInfo',
            query: {
              val: value,
              obj: this.$route.query.contractId,
              ocompanyId: this.$route.query.ocompanyId,
            },
          })
        } else {
          this.$router.push({
            path: '/contractBase',
            query: {
              val: value,
              obj: this.$route.query.contractId,
              form: 'card',
            },
          })
        }
      } else if (this.$route.query.type == '1'||this.$route.query.type == '3') {
        //判断银行可是否被禁用
        if (value.is_enabled && value.is_enabled === true) {
          //被禁用
          Dialog.alert({
            title: '温馨提示',
            message: '该银行卡已被禁用，请联系管理员！',
            confirmButtonText: '确认',
          })
          return
        }
        api
          .bank(
            {
              contractId: this.obj,
              name: value.bank_name,
              bankNo: value.account,
            },
            { method: 'post' }
          )
          .then((res) => {
            if (res.data.status == '200') {
              Toast.success('更换成功')
                    if(this.$route.query&&this.$route.query.type&&this.$route.query.type=='3'){
                            this.$store.dispatch("doBosskgSign",{employeeAccountId:this.$route.query.employeeAccountId,contractEmployeeId:this.$route.query.contractId}).then(() => {
                                this.$router.push({
                                        // 或者使用 path
                                        path: '/contractBase',
                                        query: {
                                        // 可选：传递查询参数
                                        obj: this.$route.query.contractId
                                        }
                                    })
                                }).catch((error) => {
                                    this.$toast.fail(error);
                                });
                    }else{ 
                            this.$router.push({
                                path: '/contractList',
                            })
                    }
            
            } else {
              this.$toast(res.data.message)
            }
          })
      }
    },
    initBank() {
      this.types = this.$route.query.type
      employeeFindListByActiveUser().then((res) => {
        if (res.data.status == '200') {
          this.cardList = res.data.data.filter((item) => {
            //筛选编辑项
            return item.type === 1
          })
          for (let temp of this.cardList) {
            temp.secrecyAccount =
              '****' + temp.account.substring(temp.account.length - 4)
            temp.isShow = false
          }
          this.alipayList = res.data.data.filter((item) => {
            //筛选编辑项
            return item.type === 2
          })
          for (let temp of this.alipayList) {
            temp.isShow = false
            if (temp.account.indexOf('@') == -1) {
              temp.secrecyAccount =
                temp.account.substring(0, 3) +
                '****' +
                temp.account.substring(temp.account.length - 4)
            } else {
              temp.secrecyAccount =
                temp.account.substring(0, 3) +
                '****' +
                temp.account.substring(temp.account.indexOf('@'))
            }
          }
          this.weChatPayList = res.data.data.filter((item) => {
            //筛选编辑项
            return item.type === 3
          })
        }
      })
    },
    handleCardCheck(id, account, idNumber,bankName) {
      this.$router.push({
        path: '/CateCardNo',
        query: {
          bankName:bankName,
          type: this.types,
          obj: this.$route.query.contractId,
          id: id,
          account: account,
          idNumber: idNumber,
        },
      })
    },
    handleAlipayEdit(id, account, idNumber) {
      this.$router.push({
        path: '/AlipayEdit',
        query: {
          id: id,
          account: account,
          idNumber: idNumber,
        },
      })
    },
    handleCardDel(id, type) {
      let tip = '银行卡'
      if (type && type == 'wx') {
        tip = '微信'
      }
      Dialog.confirm({
        title: '解绑提示',
        message: '该操作将删除该' + tip + '，确定要解绑？',
      })
        .then(() => {
          employeeBankCardDeleteAction(id).then((res) => {
            if (res.data.status == '200') {
              this.$toast('解绑成功')
              this.initBank()
            } else {
              this.$toast(res.data.message)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    handleAlipayDel(id) {
      Dialog.confirm({
        title: '解绑提示',
        message: '该操作将删除该支付宝，确定要解绑？',
      })
        .then(() => {
          employeeBankCardDeleteAction(id).then((res) => {
            if (res.data.status == '200') {
              this.$toast('解绑成功')
              this.initBank()
            } else {
              this.$toast(res.data.message)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },

    toAddBank() {
      if (this.cardList.length < 5) {
        this.$router.push({
          path: '/AddCardNo',
          query: { type: this.types, obj: this.$route.query.contractId },
        })
      } else {
        this.$toast('只能添加五张银行卡!')
      }
    },
    //增加微信支付
    toAddWeChatPay() {
      if (this.weChatPayList.length == 0) {
        //判断是是不是微信公众号环境
        browserUA().then((browserType) => {
          if (browserType == 'WX') {
            //弹出用户授权信息
            this.showWeChatPay = true
          } else {
            Dialog.alert({
              title: '温馨提示',
              message:
                ' 请关注并前往“' +
                this.$store.getters.platformName +
                '”微信公众号中操作',
              confirmButtonText: '知道了',
              theme: 'round-button',
            }).then(() => {
              // on close
            })
          }
        })
      } else {
        this.$toast('只能添加一个微信账号!')
      }
    },
    toAddAliPay() {
      if (this.alipayList.length == 0) {
        this.$router.push({
          path: '/AddAlipay',
          query: { type: this.types, obj: this.$route.query.contractId },
        })
      } else {
        this.$toast('只能添加一个支付宝账号!')
      }
    },

    handleCardShow(cardList, index) {
      cardList[index].isShow = cardList[index].isShow ? false : true
      this.$forceUpdate()
    },
    //查询hasWeChatPay 查询是否开通微信支付
    //添加微信支付
    checkPayType() {
      checkPayType().then((res) => {
        if (res.data != null) {
          // 返回数据为map
          this.hasAlipay = res.data.data['hasAlipay']
          this.hasWeChatPay = res.data.data['hasWeChatPay']
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.cardListPage {
  position: relative;
  padding: 8px;
  .weChatPayList {
    .weChatPay {
      .van-icon {
        opacity: 0;
      }
    }
  }
}
.active-bank {
  width: 0.6867rem;
  position: absolute;
  right: 0.08rem;
  top: 0.2rem;
}
.list {
  .item {
    position: relative;
    display: block;
    width: 100%;
    height: 128px;
    margin: 0 auto;
    padding: 22px 16px 22px 22px;
    box-sizing: border-box;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    &.disable-card {
      opacity: 0.5;
    }
    &.type_zhaoshang {
      background-image: url(./assets/bg_bank_zhaoshang.png);
    }
    &.type_jianshe {
      background-image: url(./assets/bg_bank_jianshe.png);
    }
    &.type_jiaotong {
      background-image: url(./assets/bg_bank_jiaotong.png);
    }
    &.type_youzheng {
      background-image: url(./assets/bg_bank_youzheng.png);
    }
    &.type_gongshang {
      background-image: url(./assets/bg_bank_gongshang.png);
    }
    &.type_nongye {
      background-image: url(./assets/bg_bank_nongye.png);
    }
    &.type_zhongguo {
      background-image: url(./assets/bg_bank_zhongguo.png);
    }
    &.type_zhongxin {
      background-image: url(./assets/bg_bank_zhongxin.png);
    }
    &.type_guangda {
      background-image: url(./assets/bg_bank_guangda.png);
    }
    &.type_huaxia {
      background-image: url(./assets/bg_bank_huaxia.png);
    }
    &.type_minsheng {
      background-image: url(./assets/bg_bank_minsheng.png);
    }
    &.type_guangfa {
      background-image: url(./assets/bg_bank_guangfa.png);
    }
    &.type_pingan {
      background-image: url(./assets/bg_bank_pingan.png);
    }
    &.type_hengsheng {
      background-image: url(./assets/bg_bank_hengsheng.png);
    }
    &.type_zhada {
      background-image: url(./assets/bg_bank_zhada.png);
    }
    &.type_huifeng {
      background-image: url(./assets/bg_bank_huifeng.png);
    }
    &.type_dongya {
      background-image: url(./assets/bg_bank_dongya.png);
    }
    &.type_zheshang {
      background-image: url(./assets/bg_bank_zheshang.png);
    }
    &.type_hengfeng {
      background-image: url(./assets/bg_bank_hengfeng.png);
    }
    &.type_pufa {
      background-image: url(./assets/bg_bank_pufa.png);
    }
    &.type_xingye {
      background-image: url(./assets/bg_bank_xingye.png);
    }
    &.type_shanghai {
      background-image: url(./assets/bg_bank_shanghai.png);
    }
    &.type_beijing {
      background-image: url(./assets/bg_bank_beijing.png);
    }
    &.type_other {
      background-image: url(./assets/bg_bank_other.png);
    }
    &.alipay {
      background-image: url(./assets/alipay.png);
    }
    &.weChatPay {
      background-image: url(./assets/bg_weChatPay.png);
    }
    .tip {
      font-size: 12px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0 0 12px 12px;
      color: #fff;
      position: absolute;
      right: 4px;
      bottom: 1px;
      display: block;
      height: 22px;
      line-height: 22px;
      text-align: center;
      padding: 0 6px;
      width: calc(100% - 8px);
      box-sizing: border-box;
    }
    .uncheckBox {
      position: absolute;
      top: 7px;
      left: 3px;
      bottom: 1px;
      right: 3px;
      border-radius: 10px;
      background: rgba(0, 0, 0, 0.5);
      z-index: 88;
      .delBtn {
        right: 90px;
        bottom: 15px;
      }
    }
    .delBtn {
      position: absolute;
      right: 16px;
      bottom: 16px;
      width: 70px;
      height: 28px;
      line-height: 28px;
      background: transparent;
      color: #fff;
      border-radius: 4px;
      font-size: 16px;
      z-index: 99;

      & + .delBtn {
        right: 90px;
      }
    }
    .line_top {
      overflow: hidden;
      height: 30px;

      & > span {
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        &.bankName {
          float: left;
          padding-left: 40px;
          max-width: 10em;
        }
      }
    }

    .line_no {
      & > span {
        display: inline-block;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        max-width: 80%;
      }

      /deep/ .van-icon {
        display: inline-block;
        vertical-align: middle;
        color: #fff;
        font-size: 18px;
        font-weight: 600;
        margin: 6px 8px 0;
      }
    }
  }
}

.public_empty_section {
  border-radius: 5px;
  top: 0;
}

.bottom {
  background: #fff;
  text-align: center;
  margin-top: 8px;
  border-radius: 5px;
  padding: 35px 10px 20px;

  .van-col {
    padding: 10px;
  }

  p {
    font-size: 12px;
    color: #999;
    line-height: 50px;
  }
}
</style>
<style lang="less">
.cardListPage {
  .codeDialog {
    color: #333;
    [class*='van-hairline']:after {
      border: none;
    }
    .van-dialog__header {
      font-size: 15px;
      font-weight: bold;
    }
    .content {
      padding: 6px 24px;
      line-height: 24px;
      font-size: 14px;
      .grey-label {
        color: #999;
      }
      .top-content {
        p {
          &:last-of-type {
            text-indent: 2em;
          }
        }
      }
      .bow-content {
        border: 1px dashed #999;
        text-align: center;
        padding: 16px 0;
        margin-top: 6px;
        p {
          &:first-of-type {
            margin-bottom: 14px;
          }
        }
      }
    }
    .van-button__content {
      width: 108px;
      text-align: center;
      border: 1px solid rgb(51, 51, 51);
      height: 36px;
      border-radius: 6px;
      margin-right: 6px;
    }
    .van-button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin: 12px 0 8px;
      font-size: 15px;
      &.van-dialog__confirm {
        justify-content: flex-start;
        .van-button__content {
          margin-right: 0;
          margin-left: 6px;
          background: #6c7ef3;
          color: #fff;
          border-color: #6c7ef3;
        }
      }
    }
  }
}
</style>
